"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnappableMode = void 0;

var _utils = require("../utils");

var _geojsonEditMode = require("./geojson-edit-mode");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _createForOfIteratorHelper(o) {
  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) {
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var it,
      normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SnappableMode = /*#__PURE__*/function (_GeoJsonEditMode) {
  _inherits(SnappableMode, _GeoJsonEditMode);

  var _super = _createSuper(SnappableMode);

  function SnappableMode(handler) {
    var _this;

    _classCallCheck(this, SnappableMode);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "_handler", void 0);

    _this._handler = handler;
    return _this;
  }

  _createClass(SnappableMode, [{
    key: "_getSnappedMouseEvent",
    value: function _getSnappedMouseEvent(event, snapSource, snapTarget) {
      return Object.assign(event, {
        mapCoords: snapTarget.geometry.coordinates,
        pointerDownMapCoords: snapSource && snapSource.geometry.coordinates
      });
    }
  }, {
    key: "_getPickedSnapTarget",
    value: function _getPickedSnapTarget(picks) {
      return (0, _utils.getPickedEditHandles)(picks).find(function (handle) {
        return handle.properties.editHandleType === 'snap-target';
      });
    }
  }, {
    key: "_getPickedSnapSource",
    value: function _getPickedSnapSource(pointerDownPicks) {
      return (0, _utils.getPickedSnapSourceEditHandle)(pointerDownPicks);
    }
  }, {
    key: "_getUpdatedSnapSourceHandle",
    value: function _getUpdatedSnapSourceHandle(snapSourceHandle, data) {
      var _snapSourceHandle$pro = snapSourceHandle.properties,
          featureIndex = _snapSourceHandle$pro.featureIndex,
          positionIndexes = _snapSourceHandle$pro.positionIndexes;

      if (!Array.isArray(positionIndexes)) {
        return snapSourceHandle;
      }

      var snapSourceFeature = data.features[featureIndex]; // $FlowFixMe

      var snapSourceCoordinates = positionIndexes.reduce(function (a, b) {
        return a[b];
      }, snapSourceFeature.geometry.coordinates);
      return _objectSpread({}, snapSourceHandle, {
        geometry: {
          type: 'Point',
          coordinates: snapSourceCoordinates
        }
      });
    } // If additionalSnapTargets is present in modeConfig and is populated, this
    // method will return those features along with the features
    // that live in the current layer. Otherwise, this method will simply return the
    // features from the current layer

  }, {
    key: "_getSnapTargets",
    value: function _getSnapTargets(props) {
      var _ref = props.modeConfig || {},
          additionalSnapTargets = _ref.additionalSnapTargets;

      additionalSnapTargets = additionalSnapTargets || [];
      var features = [].concat(_toConsumableArray(props.data.features), _toConsumableArray(additionalSnapTargets));
      return features;
    }
  }, {
    key: "_getSnapTargetHandles",
    value: function _getSnapTargetHandles(props) {
      var handles = [];

      var features = this._getSnapTargets(props);

      for (var i = 0; i < features.length; i++) {
        // Filter out the currently selected feature(s)
        var isCurrentIndexFeatureNotSelected = !props.selectedIndexes.includes(i);

        if (isCurrentIndexFeatureNotSelected) {
          var geometry = features[i].geometry;
          handles.push.apply(handles, _toConsumableArray((0, _utils.getEditHandlesForGeometry)(geometry, i, 'snap-target')));
        }
      }

      return handles;
    } // If no snap handle has been picked, only display the edit handles of the
    // selected feature. If a snap handle has been picked, display said snap handle
    // along with all snappable points on all non-selected features.

  }, {
    key: "getGuides",
    value: function getGuides(props) {
      var modeConfig = props.modeConfig,
          lastPointerMoveEvent = props.lastPointerMoveEvent;

      var _ref2 = modeConfig || {},
          enableSnapping = _ref2.enableSnapping;

      var guides = {
        type: 'FeatureCollection',
        features: _toConsumableArray(this._handler.getGuides(props).features)
      };

      if (!enableSnapping) {
        return guides;
      }

      var snapSourceHandle = lastPointerMoveEvent && this._getPickedSnapSource(lastPointerMoveEvent.pointerDownPicks); // They started dragging a handle
      // So render the picked handle (in its updated location) and all possible snap targets


      if (snapSourceHandle) {
        var _guides$features;

        (_guides$features = guides.features).push.apply(_guides$features, _toConsumableArray(this._getSnapTargetHandles(props)).concat([this._getUpdatedSnapSourceHandle(snapSourceHandle, props.data)]));

        return guides;
      } // Render the possible snap source handles


      var features = props.data.features;

      var _iterator = _createForOfIteratorHelper(props.selectedIndexes),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var index = _step.value;

          if (index < features.length) {
            var _guides$features2;

            var geometry = features[index].geometry;

            (_guides$features2 = guides.features).push.apply(_guides$features2, _toConsumableArray((0, _utils.getEditHandlesForGeometry)(geometry, index, 'snap-source')));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return guides;
    }
  }, {
    key: "_getSnapAwareEvent",
    value: function _getSnapAwareEvent(event, props) {
      var snapSource = this._getPickedSnapSource(props.lastPointerMoveEvent.pointerDownPicks);

      var snapTarget = this._getPickedSnapTarget(event.picks);

      return snapSource && snapTarget ? this._getSnappedMouseEvent(event, snapSource, snapTarget) : event;
    }
  }, {
    key: "handleStartDragging",
    value: function handleStartDragging(event, props) {
      this._handler.handleStartDragging(event, props);
    }
  }, {
    key: "handleStopDragging",
    value: function handleStopDragging(event, props) {
      this._handler.handleStopDragging(this._getSnapAwareEvent(event, props), props);
    }
  }, {
    key: "handleDragging",
    value: function handleDragging(event, props) {
      this._handler.handleDragging(this._getSnapAwareEvent(event, props), props);
    }
  }, {
    key: "handlePointerMove",
    value: function handlePointerMove(event, props) {
      this._handler.handlePointerMove(this._getSnapAwareEvent(event, props), props);
    }
  }]);

  return SnappableMode;
}(_geojsonEditMode.GeoJsonEditMode);

exports.SnappableMode = SnappableMode;